import React, {useEffect, useState} from 'react';
import {connect} from "react-redux";
import Loader from "./layout/loading/loader";
import PageTitle from "./layout/PageTitle";
import {Checkbox, FormControlLabel} from "@mui/material";
import Grid from "@mui/material/Grid2";
import SchemaIcon from "@mui/icons-material/Schema";
import {rhdataActions} from "../../modules/rhdata/rhdata.actions.js";
import RHDataTable from "./rh/RHDataTable.js";


function RHDataPage({dispatch, ...props}) {
    const [showExpired, setShowExpired] = useState(false); // Par défaut, masquer les contrats expirés

    useEffect(() => {
        if (!props.rhdatas && !props.loading && !props.error) {
            dispatch(rhdataActions.fetchRhdatas())
        }
    }, [props.rhdatas, props.loading, props.error]);

    const isExpired = (rhdata) => {
        try {
            const fin = rhdata?.contratTravail?.dateFin;
            if (!fin) return false;
            const finDate = new Date(fin);
            const today = new Date();
            // Compare at day precision
            finDate.setHours(0,0,0,0);
            today.setHours(0,0,0,0);
            return finDate < today;
        } catch (e) {
            return false;
        }
    };

    const filtered = props.rhdatas?.filter(d => showExpired || !isExpired(d));

    const handleDelete = (laveuse) => {
        dispatch(rhdataActions.deleteRhdata(laveuse.id));
    }

    return (
        <>
            <PageTitle title={"Données RH"} icon={<SchemaIcon/>}/>
            {props.loading &&
                <Loader/>
            }
            {!props.loading &&
                <>
                    <Grid container alignItems="center" className="mt-2" style={{marginBottom: '0.5rem'}}>
                        <Grid item>
                            <FormControlLabel
                                control={<Checkbox checked={showExpired} onChange={(e) => setShowExpired(e.target.checked)} />}
                                label="Afficher les contrats expirés"/>
                        </Grid>
                    </Grid>
                    <Grid container>
                        <RHDataTable rhdatas={filtered}/>
                    </Grid>
                </>
            }
        </>
    )
}

const mapStateToProps = function (state) {
    return {
        rhdatas: state.rhdata.rhdatas,
        loading: state.rhdata.loading,
        error: state.rhdata.error
    }
}

export default connect(mapStateToProps)(RHDataPage);
